import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { DialogModalComponent } from '../../shared/components/dialog-modal/dialog-modal.component';
import { UsersRoutingModule } from './users.routing';
import { UsersGridComponent } from './pages/users-grid/users-grid.component';
import { NewUserComponent } from './pages/new-user/new-user.component';
import { PendingChangesGuard } from '../../core/guards/pending-changes.guard';
import { NgxLoadingModule } from 'ngx-loading';
import { PatientsGridComponent } from './pages/patients-grid/patients-grid.component';
import { EditUserComponent } from './pages/edit-user/edit-user/edit-user.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        UsersRoutingModule,
        ReactiveFormsModule,
        SharedModule,
        NgxLoadingModule
    ],
    exports: [],
    declarations: [UsersGridComponent, NewUserComponent, PatientsGridComponent, EditUserComponent],
    providers: [PendingChangesGuard],
    entryComponents: [DialogModalComponent, NewUserComponent]
})
export class UsersModule { }
